export default __webpack_public_path__ + "static/media/star-border-white.cf9a96e8.svg";